import React from 'react';
import { Link } from 'react-router-dom';

export default function Logo({ 
  primaryText = 'Easy', 
  secondaryText = 'Suite',
  primaryColor = '#FF8D28',
  secondaryColor = '#000000',
  to = '/',
  className = ''
}) {
  return (
    <Link 
      to={to} 
      className={`font-montserrat font-extrabold text-lg md:text-[22px] tracking-[-0.42px] leading-[36.44px] align-middle ${className}`}
      style={{ color: primaryColor }}
    >
      {primaryText} <span style={{ color: secondaryColor }} className="font-extrabold">{secondaryText}</span>
    </Link>
  );
}
